<div class="user">
  <craft-user-icon class="icon" [user]="user"></craft-user-icon>
  <div class="text">
    <div [matTooltip]="user.email || ''" [matTooltipShowDelay]="1000" class="ellipsis">{{ user.email }}</div>
    <span class="pr-6">(Waiting for response)</span>
    <a (click)="resendInvite($event)" class="resend">Resend</a>
  </div>
</div>
